import { MobiDocument } from './MobiDocument';

export class VaccinDocument extends MobiDocument{
    private _id : string;
    private _rev : string;
    private id : number;
    private libelle: string;
    private date: string;

    
    public constructor(vaccin : any){
        super()
        this._id = vaccin._id;
        this._rev = vaccin._rev;
        this.id = vaccin.id;
        this.libelle = vaccin.libelle;
        this.date = "";
    }

    public get_id(): string {
        return this._id;
    }

    public set_id(_id: string): void {
        this._id = _id;
    }

    public get_rev(): string {
        return this._rev;
    }

    public set_rev(_rev: string): void {
        this._rev = _rev;
    }

    public getId(): number {
        return this.id;
    }

    public setId(id: number): void {
        this.id = id;
    }

    public getLibelle(): string {
        return this.libelle;
    }

    public setLibelle(libelle: string): void {
        this.libelle = libelle;
    }

    public getDate(): string {
        return this.date;
    }

    public setDate(date: string): void {
        this.date = date;
    }
}